module.exports = __webpack_public_path__ + "img/beijing@2x.3ca4680a.png";